import React from 'react'
import { Image, Row, Col } from 'react-bootstrap';
import parse from 'html-react-parser';
import { useStateValue } from '../../utilities/StateProvider';
import { PANDA_PARTY_RESUMEN } from '../../../images/images';
import ProductGroup from './ProductGroup';

export default function ProductResume() {

    const [ { cart, isInterior }, _ ] = useStateValue();

    const renderProductList = () => {
        
        const productList = Object.values(cart).filter(entry => {return(entry.type === 'products')})

        const groupProducts = {};
        
        productList.forEach((entry) => {
            const value = entry.category;
            (groupProducts[value] = groupProducts[value] || []).push(entry);
        });

        const test = Object.values(groupProducts).map(entry => 
            <ProductGroup content={entry} category={{slug: entry[0].category, name: entry[0].categoryName }}/>
        );

        return test
    };
     
    const renderPandaPartyList = () => {
        
        const productList = Object.values(cart).filter(entry => {return(entry.type === 'pandaparty')});

        return productList.map(entry => (
            <Row className="service-row">
                <Col xs="4">
                    <Image src={PANDA_PARTY_RESUMEN} roundedCircle height={80}/>
                    <div className="title">{entry.name}</div>
                </Col>
                <Col xs="5" className="quantity promo-content">
                    {entry && parse(entry.content)};
                </Col>
                <Col xs="3" className="price">
                    <span>${((!isInterior) ? entry.price : entry.price_interior) * entry.quantity}</span>
                </Col>
            </Row>
        ))
    }

    return (
        <Row>
            <Col xs="12" className="product-resume">
                {renderProductList()}
                {renderPandaPartyList()}
            </Col>
        </Row>
    )
}
